module.exports = __webpack_public_path__ + "static/media/FujiInstaxMini3.39by2.13_13.795018ab.webp";